import React from 'react';

const Logo: React.FC = () => {
  return (
    <img
      src="/logo-transparent.svg"
      alt="Band Space logo"
      style={{ height: '42px', width: 'auto' }}
      loading="eager"
      decoding="sync"
    />
  );
};

export default Logo; 